// extracted by mini-css-extract-plugin
export default {"root":"CaseCreateDialogFieldsStep_root__4bHEm","field":"CaseCreateDialogFieldsStep_field__JNKvp"};